const get = (selector, Root = document) => Root.querySelector(selector);
const getAll = (selector, Root = document) => Root.querySelectorAll(selector);
const btn = get('.btn-bar-toggle');
const subitems=getAll('.sub_items');
const wrapMenu=get('.wrap-main-menu');
if (btn) {
    btn.addEventListener('click', () => {
        wrapMenu.classList.toggle('active');
        if (subitems[0].classList.contains('active')) {
            subitems[0].classList.remove('active')
        } else {
            handleActive(subitems)
            if(wrapMenu.classList.contains('active')){
                subitems[0].classList.add('active')
            }
        }
    })
// add subitems
  subitems.forEach(element=>{
    element.addEventListener('click',(e)=>{
        handleActive(subitems)// delete clas active
         //verifica si esta activo
        if(!wrapMenu.classList.contains('active')){
            wrapMenu.classList.add('active')
        }

        if (element.classList.contains('active')) {
            element.classList.remove('active')
        } else {

            element.classList.add('active')
        }
    })
  })

  const handleActive=(items)=>{
        let active=null;
        items.forEach(element=>{
            element.classList.remove('active')
        })
  }
  
//     get('.sub_items').addEventListener('click', () => {
//         get('.wrap-main-menu').classList.toggle('active');

//         if (get('.sub_items').parentElement.classList.contains('active')) {
//             get('.sub_items').parentElement-classList.remove('active')
//         } else {

//             get('.sub_items').classList.add('active')
//         }
//     })
}
import { Tooltip } from 'bootstrap'
import {Spinner} from './loandig'
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

var swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination],
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

//   Tbas cusctom
class Htabs {
    constructor(config) {
        this.tabsNav = document.querySelector(config.tabsNav),
            this.tabsNavItems = document.querySelectorAll(config.tabsNavItems);
        this.panels = document.querySelectorAll(config.panels)
        // console.log( this.tabsNavItems)
        if (this.tabsNavItems.length == 0) {
            return false;
        }
        this.appendDecorationNav()
        this.findActiveItem()
        this.initTabs()
    }
    //set active nav element
    setActiveItem = elem => {
        this.tabsNavItems.forEach(el => {
            el.classList.remove('js-active');

        });
        elem.classList.add('js-active');

    };
    //find active nav element
    findActiveItem = () => {
        let activeIndex = 0;
        for (let i = 0; i < this.tabsNavItems.length; i++) {
            if (this.tabsNavItems[i].classList.contains('js-active')) {
                activeIndex = i;
                break;
            };
        };
        return activeIndex;
    };
    //find active nav elements parameters: left coord, width
    findActiveItemParams = (activeItemIndex) => {
        const activeTab = this.tabsNavItems[activeItemIndex];
        //width of elem
        const activeItemWidth = activeTab.offsetWidth - 1;
        //left coord in the tab navigation
        const activeItemOffset_left = activeTab.offsetLeft;
        return [activeItemWidth, activeItemOffset_left];
    };
    //appending decoration block to an active nav element
    appendDecorationNav = () => {

        //creating decoration element
        let decorationElem = document.createElement('div');

        decorationElem.classList.add('tabs__nav-decoration');
        decorationElem.classList.add('js-decoration');

        //appending decoration element to navigation
        this.tabsNav.append(decorationElem);

        //appending styles to decoration element
        return decorationElem;
    };

    //appending styles to decoration nav element
    styleDecorElem = (elem, decorWidth, decorOffset) => {
        elem.style.width = `${decorWidth}px`;
        elem.style.transform = `translateX(${decorOffset}px)`;
    };

    //find active panel

    findActivePanel = index => {

        return this.panels[index];

    };

    //set active panel class
    setActivePanel = index => {

        this.panels.forEach(el => {

            el.classList.remove('js-active');

        });

        this.panels[index].classList.add('js-active');

    };
    // run tabs
    initTabs() {
        this.tabsNav.addEventListener('click', e => {
            e
            const navElemClass = 'tabs__nav-item';
            let navitem = '';
            if (e.target.classList.contains('icons')) {
                navitem = e.target.parentElement.parentElement;
            }
            if (e.target.classList.contains('link')) {
                navitem = e.target.parentElement;
            }
            // console.log(navitem);
            //check if we click on a nav item
            if (!e.target.classList.contains(navElemClass)) {

                const clickedTab = navitem;
                //   console.log(clickedTab);
                const activeItemIndex = Array.from(this.tabsNavItems).indexOf(clickedTab);

                //set active nav item
                this.setActiveItem(clickedTab);

                //find active nav item
                const activeItem = this.findActiveItem();

                //find active nav item params
                const [decorWidth, decorOffset] = this.findActiveItemParams(activeItem);

                //setting styles to the decoration elem
                const decorElem = document.querySelector('.js-decoration');

                this.styleDecorElem(decorElem, decorWidth, decorOffset);

                //find active panel
                this.findActivePanel(activeItemIndex);

                //set active panel
                this.setActivePanel(activeItemIndex);

            }
        })
    }
}

const newTabs = new Htabs({
    tabsNav: '.tabs__nav',
    tabsNavItems: '.tabs__nav-item',
    panels: '.tabs__panel'
});

//  contact form inquiry now
const spins = new Spinner({
    selector: '.spinner',
    width:25, 
    height:25,
    text: 'Sending..',
    color: "#d7b672",
    background:"#fff",
  })
const contact_us = get('.form-contact_us')
if (contact_us) {
    const url = contact_us.getAttribute('action');
    contact_us.addEventListener('submit', (e) => {
        e.preventDefault()
        spins.active()
        const db = new FormData()
        db.append('tours',contact_us.tours.value)
        db.append('dateStart',contact_us.dateStart.value)
        db.append('numTravellers',contact_us.numTravellers.value)
        db.append('fullName',contact_us.fullName.value)
        db.append('email',contact_us.email.value)
        db.append('description',contact_us.description.value)
        fetch(url, { method: 'POST', body: db })
            .then(res => res.json())
            .then(data => {
                if(data.status===200){
                    spins.hide()
                    contact_us.reset();
                    alert(data.message);
                }
                else{
                    spins.hide()
                    alert('Sending Error'); 
                }
            })
            .catch(error=>{
                console.log(error)
                spins.hide()
               })

    })
}

const fm=get('.page_form')
const loandig = new Spinner({
    selector: '.loandig',
    width:25, 
    height:25,
    text: 'Sending..',
    color: "#d7b672",
    background:"#fff",
  })
if(fm){
    const urls = fm.getAttribute('action');
    fm.addEventListener('submit', (e) => {
        e.preventDefault()
        loandig.active()
        const dbform = new FormData()
        dbform.append('Subject',fm.Subject.value)
        dbform.append('message',fm.message.value)
        dbform.append('fullName',fm.fullName.value)
        dbform.append('email',fm.email.value)
        fetch(urls, { method: 'POST', body: dbform })
            .then(res => res.json())
            .then(data => {
                if(data.status===200){
                    loandig.hide()
                    fm.reset();
                    alert(data.message);
                }
                else{
                    loandig.hide()
                    alert('Sending Error'); 
                }
            })
            .catch(error=>{
             console.log(error)
             loandig.hide()
            })

    })
}